/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, RouteComponentProps } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { useGlobalContext } from "../../../context";

// importing from widgets
import TextVisualizer from "../../../components/widgets/TextVisualizer";
import { Modal } from "../../../components/widgets/Popup";

import {
  request,
  getActiveRequest,
  createSuccess,
  createNote,
  rateRequest,
  getUsers,
  getQuestion,
  getParameter,
} from "../../../store/modules/RequestStore";
import {
  associateCI,
  removeCI,
  removeFile,
} from "../../../store/modules/RuleStore";
import { user } from "../../../store/modules/UserStore";
import { getCIs } from "../../../store/modules/CIStore";
import TabNotes from "../TabNotes";
import TabFiles from "../TabFiles";
import TabAssets from "../TabAssets";
import { OptionTypeBase } from "react-select";
import TabWorkOrder from "../TabWorkOrder";
import TabForm from "../TabForm";
import {
  Asunto,
  Dash,
  Information,
  InformationRow,
  RequestInfo,
  Tab,
  TabButton,
  EncuestaBtn,
  Encuesta,
  EncuestaForm,
  Observaciones,
  EncuestaSubmit,
  ThumbImage,
} from "./RequestDetailElements";

import { ConfirmRemoveCi } from "../../../components/RequestPage/TabAssets/Asset";

import emojiHappy from "../../../components/svg/emojiHappy.png";
import emojiStale from "../../../components/svg/emojiStale.png";

import { FileRemoveModalContent } from "../../../components/RequestPage/TabFiles/File";

import Footer from '../../../components/layout/Footer';
import { useTranslation } from "react-i18next";
import TranslatableText from "../../../components/Multilanguage/TranslatableText";
import { useTranslationContext } from "../../../context/TranslationContext";
import { request as request2, getSelfServiceConfiguration } from "../../../store/modules/RequestStore"; // fechaVencimiento

type TParams = { id: string };

const FaqDetail = ({ match }: RouteComponentProps<TParams>) => {
  const dispatch = useDispatch();
  const { translateText, targetLang } = useTranslationContext()

  const [translatedDescription, setTranslatedDescription] = useState<string | undefined>('')

  const { t } = useTranslation()

  const requestState = useSelector(request);
  const userDetails = useSelector(user);
  const configurationSelf = useSelector(request2);  // fechaVencimiento
  const { primaryColor, secundaryColor, color3, setNewRequestRedirect } =
    useGlobalContext();

  const [description, setDescription] = useState("");
  const [hideEncuesta, setHideEncuesta] = useState(1);
  const [reload, setReload] = useState(false);
  const [checked, setChecked] = useState("");
  const [observations, setObservations] = useState("");
  const [isUseful, setIsUseful] = useState(false);
  const [hasComplaint, setHasComplaint] = useState(false);
  const [hidenInfo, setHidenInfo] = useState(true);
  const [showSurveyButton, setShowSurveyButton] = useState(false);

  useEffect(() => {

    dispatch(getActiveRequest(match.params.id));
    dispatch(getCIs(userDetails.username));
    dispatch(getUsers(userDetails.CompanyID));
    dispatch(getQuestion());
    dispatch(getSelfServiceConfiguration()); // Cargar configuración de self service  // fechaVencimiento
    if (requestState.createSuccess) {
      notify();
      dispatch(createSuccess(false));
    }
    setNewRequestRedirect(false);
  }, []);

  // useEffect(() => {
  //   if (reload) {

  //     setTimeout(() => dispatch(getActiveRequest(match.params.id)), 200);
  //     setHideEncuesta(3)
  //   }

  // }, [reload]);

  useEffect(() => {
    const fetchParameter = async () => {
      const paramShowSurveyButton = await getParameter({ parameterName: "selfServiceOcultarBotonEncuesta" });
      if (
        paramShowSurveyButton?.data?.status === "Ok" &&
        paramShowSurveyButton.data.values.parameterValue.toString() === "1"
      ) {
        setShowSurveyButton(true);
      } else {
        setShowSurveyButton(false);
      }
    };

    fetchParameter();
  }, []);

  useEffect(() => {
    if (checked === "si") {
      setIsUseful(true);
      setHasComplaint(false);
    }
    else if (checked === "no") {
      setIsUseful(false);
      setHasComplaint(true);
    }
  }, [checked]);

  useEffect(() => {
    const translateHTML = async () => {
      try {
        const result = await translateText(requestState.active.Description, "html");
        setTranslatedDescription(result);
      } catch (error) {
        setTranslatedDescription(requestState.active.Description);
      }
    };

    if (targetLang && targetLang !== "es") {
      translateHTML();
    } else {
      setTranslatedDescription(requestState?.active?.Description);
    }
  }, [requestState.active.Description, targetLang]);

  const notify = () => {
    toast.success(`${t("requestDetail.toast1")} ${match.params.id} ${t("requestDetail.toast2")}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: "create-reuqest-success",
    });
  };

  const [noteType, setNoteType] = useState<OptionTypeBase>({
    value: "",
    label: "",
  });

  const [noteUser, setNoteUser] = useState<OptionTypeBase>({
    value: "",
    label: "",
  });

  const handleNoteType = (e: any) => {
    setNoteType(e);
  };

  const handleUser = (e: any) => {
    setNoteUser(e);
  };

  const handleCreateNote = () => {
    if (noteType && noteType.value !== "" && description !== "") {
      dispatch(createNote(match.params.id, description, noteType.value));
      setNoteType({ label: "", value: "" });
      setDescription("");
    } else {
      toast.error(t("requestDetail.toast3"), {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setNoteType({ label: "", value: "" });
      setDescription("");
    }
  };

  // RESPUESTA DE LA ENCUESTA//
  const submitRating = (e: any) => {
    e.preventDefault();
    let questionsCalifications = [];
    if (isUseful && hasComplaint) {
      questionsCalifications.push(5);
    } else if (!isUseful && !hasComplaint) {
      questionsCalifications.push(1);
    }
    if (checked !== "") {
      dispatch(
        rateRequest(
          parseInt(match.params.id),
          isUseful,
          hasComplaint,
          observations,
          questionsCalifications
        )
      );
      setChecked("");
      setObservations("");
      setHideEncuesta(1)
      // setReload(true)
    } else {
      setHidenInfo(false);
    }
  };

  const associateCItoRequest = (ci: string) => {
    dispatch(associateCI(ci, match.params.id));
    toast.success(`${t("requestDetail.toast4")} ${ci} ${t("requestDetail.toast5")}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: "create-reuqest-success",
    });
  };

  const [tab, setTab] = useState(0);

  const [ciToRemove, setCiToRemove] = useState("");
  const [modalRemoveCI, setModalRemoveCI] = useState(false);

  const handleRemoveCI = (ci: string) => {
    dispatch(removeCI(ci, match.params.id));
    setModalRemoveCI(false);
    toast.success(`${t("requestDetail.toast4")} ${ci} ${t("requestDetail.toast6")}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: "create-reuqest-success",
    });
  };

  const [modalRemoveFile, setModalRemoveFile] = useState(false);
  const [filesToRemoveList, setfilesToRemoveList] = useState([]);

  const handleRemoveFiles = () => {
    filesToRemoveList.map((item: any) => {
      dispatch(removeFile(item.AttachmentID, match.params.id));
      toast.success(`${t("requestDetail.toast7")} ${item.AttachmentID} ${t("requestDetail.toast6")}`, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "create-reuqest-success",
      });
      return null;
    });
    setfilesToRemoveList([]);
  };

  return (
    <div className="mt-12">
      <Link to={"/request/all"}>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 17L6 12M6 12L11 7M6 12L18 12"
            stroke="#111827"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
      <RequestInfo className="grid grid-cols-2 gap-4">
        <Asunto className="w-full flex flex-col p-4">
          <h1
            className={`text-2xl mb-2 font-title text-${primaryColor}`}
            style={{
              width: "100%",
              wordBreak: "break-word",
              overflow: "hidden",
              whiteSpace: "break-spaces",
            }}
          >
            <TranslatableText text={requestState.active.Subject} />
          </h1>
          <span>{t("requestDetail.description")}</span>
          <TextVisualizer value="400">
            {`${requestState.active.Description}`}
          </TextVisualizer>
        </Asunto>
        <div className="flex flex-col gap-2 items-center">
          <Information
            hoverBg={secundaryColor}
            className={`w-full hover:border py-4 px-14 mt-8 text-md`}
          >
            <InformationRow>
              <h1 className="font-title text-blue-600">
                {t("requestDetail.request")}
              </h1>
              <Dash>-</Dash>
              <h1 className="font-body">{match.params.id}</h1>
            </InformationRow>
            <InformationRow>
              <h1 className="font-title text-blue-600">
                {t("requestDetail.state")}
              </h1>
              <Dash>-</Dash>
              <h1 className="font-body">
                {requestState.active.StatusName ? (
                  <TranslatableText text={requestState.active.StatusName} />
                ) : (
                  requestState.active.StatusName
                )}
                /
                {requestState.active.ServiceOrder?.StatusName ? (
                  <TranslatableText
                    text={requestState.active.ServiceOrder?.StatusName}
                  />
                ) : (
                  requestState.active.ServiceOrder?.StatusName
                )}
              </h1>
            </InformationRow>
            <InformationRow>
              <h1 className="font-title text-blue-600">
                {t("requestDetail.responsible")}
              </h1>
              <Dash>-</Dash>
              <h1 className="font-body">
                {requestState.active.ServiceOrder
                  ? requestState.active.ServiceOrder.TechnicianName
                  : ""}
              </h1>
            </InformationRow>
            <InformationRow>
              <h1 className="font-title text-blue-600">
                {t("requestDetail.area")}{" "}
              </h1>
              <Dash>-</Dash>
              <h1 className="font-body">
                {requestState.active.ServiceOrder ? (
                  <TranslatableText
                    text={requestState.active.ServiceOrder.AreaName}
                  />
                ) : (
                  ""
                )}
              </h1>
            </InformationRow>
            <InformationRow>
              <h1 className="font-title text-blue-600">
                {t("requestDetail.service")}{" "}
              </h1>
              <Dash>-</Dash>
              <h1 className="font-body">
                {requestState.active.ServiceOrder ? (
                  <TranslatableText
                    text={requestState.active.ServiceOrder.ServiceName}
                  />
                ) : (
                  ""
                )}
              </h1>
            </InformationRow>
            {configurationSelf.selfServiceConfiguration?.activateExpirationDate && (  // fechaVencimiento
              <InformationRow>
                <h1 className="font-title text-blue-600">
                  {t("requestDetail.expirationDate")}{" "}
                </h1>
                <Dash>-</Dash>
                <h1 className="font-body">
                  {requestState.active.ServiceOrder ? (
                    <TranslatableText
                      text={requestState.active.ExpirationDate}
                    />
                  ) : (
                    ""
                  )}
                </h1>
              </InformationRow>
            )}
          </Information>
          {requestState.active.StatusID === "1" &&
            requestState.active.ServiceOrder?.StatusID === "2" &&
            hideEncuesta === 0 && !showSurveyButton ? (
            <Encuesta>
              <EncuestaForm action="">
                <div className="px-2 flex text-center">
                  <p className="font-semibold" style={{ color: "#3948ff" }}>
                    {requestState.questionPoll}
                  </p>
                </div>
                <hr className="bg-gray-300 w-full h-0.25" />
                <div className="flex justify-between align-center gap-20 py-1 px-12">
                  <div className="flex items-center justify-center">
                    <EncuestaBtn checked={checked === "si"}>
                      <ThumbImage src={emojiHappy} alt="thumbs up" />
                      <input
                        type="radio"
                        value="si"
                        hidden
                        checked={checked === "si"}
                        onChange={() => setChecked("si")}
                      />
                    </EncuestaBtn>
                  </div>
                  {/* <div className="flex items-center justify-center">
                    <EncuestaBtn checked={checked === "none"}>
                      <ThumbImage src={emojiStale} alt="thumbs down" />
                      <input
                        type="radio"
                        value="none"
                        hidden
                        checked={checked === "none"}
                        onChange={() => setChecked("none")}
                      />
                    </EncuestaBtn>
                  </div> */}
                  <div className="flex items-center justify-center">
                    <EncuestaBtn checked={checked === "no"}>
                      <ThumbImage src={emojiStale} alt="thumbs down" />
                      <input
                        type="radio"
                        value="no"
                        hidden
                        checked={checked === "no"}
                        onChange={() => setChecked("no")}
                      />
                    </EncuestaBtn>
                  </div>
                </div>
                <div className="flex justify-center text-center w-full">
                  <Observaciones
                    placeholder={t("requestDetail.remarks")}
                    value={observations}
                    onChange={(e: any) => {
                      observations.length <= 150
                        ? setObservations(e.target.value)
                        : setObservations(e.target.value.slice(0, -2));
                    }}
                  />
                </div>
                <div className="w-full">
                  {hidenInfo === false ? (
                    <div className="flex items-left justify-left text-red">
                      <p className="font-title text-red-600">
                        {t("requestDetail.selectAnswer")}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="flex items-center justify-center">
                    <EncuestaSubmit onClick={(e: any) => submitRating(e)}>
                      {t("requestDetail.send")}
                    </EncuestaSubmit>
                  </div>
                </div>
              </EncuestaForm>
            </Encuesta>
          ) : requestState.active.StatusID === "1" &&
            requestState.active.ServiceOrder?.StatusID === "2" &&
            hideEncuesta === 1 && !showSurveyButton ? (
            <Encuesta>
              <div className="px-2 flex text-center item-center justify-center">
                <p className="font-semibold" style={{ color: "#3948ff" }}>
                  {t("requestDetail.thanks")}
                </p>
              </div>
              <div className="flex items-center justify-center">
                <EncuestaSubmit onClick={() => setHideEncuesta(0)} colorGray>
                  {t("requestDetail.reportSurvey")}
                </EncuestaSubmit>
              </div>
            </Encuesta>
          ) : requestState.active.StatusID === "2" &&
            requestState.active.ServiceOrder?.StatusID === "2" ? (
            ""
          ) : (
            ""
          )}
        </div>
      </RequestInfo>
      <div>
        <nav className="flex flex-row w-full justify-start mt-14 ">
          <TabButton
            bg={secundaryColor}
            isActive={tab === 0}
            borderColor={color3}
            className={`py-2 w-full focus:outline-none rounded-t-lg font-title text-md text-lavanda `}
            onClick={() => {
              setTab(0);
            }}
          >
            {t("requestDetail.ot")}
          </TabButton>
          <TabButton
            bg={secundaryColor}
            isActive={tab === 1}
            borderColor={color3}
            className={`py-2 w-full focus:outline-none rounded-t-lg font-title text-md text-lavanda`}
            onClick={() => {
              setTab(1);
            }}
          >
            {t("requestDetail.notes")}
          </TabButton>
          <TabButton
            bg={secundaryColor}
            isActive={tab === 2}
            borderColor={color3}
            className={`py-2 w-full focus:outline-none rounded-t-lg font-title text-md text-lavanda `}
            onClick={() => {
              setTab(2);
            }}
          >
            {t("requestDetail.actives")}
          </TabButton>
          <TabButton
            bg={secundaryColor}
            isActive={tab === 3}
            borderColor={color3}
            className={`py-2 w-full focus:outline-none rounded-t-lg font-title text-md text-lavanda `}
            onClick={() => {
              setTab(3);
            }}
          >
            {t("requestDetail.archives")}
          </TabButton>
          <TabButton
            bg={secundaryColor}
            isActive={tab === 4}
            borderColor={color3}
            className={`py-2 w-full focus:outline-none rounded-t-lg font-title text-md text-lavanda `}
            onClick={() => {
              setTab(4);
            }}
          >
            {t("requestDetail.form")}
          </TabButton>
          <div className={`border-b border-gris w-full mr-1.5`}></div>
        </nav>
        <Tab
          className={`border-b border-l border-r bg-white rounded-r-lg rounded-bl-lg p-8`}
        >
          {tab === 0 ? <TabWorkOrder /> : <></>}
          {tab === 1 ? (
            <TabNotes
              noteUser={noteUser}
              noteType={noteType}
              requestState={requestState}
              handleUser={handleUser}
              handleNoteType={handleNoteType}
              description={description}
              setDescription={setDescription}
              handleCreateNote={handleCreateNote}
            />
          ) : (
            <></>
          )}
          {tab === 2 ? (
            <TabAssets
              requestState={requestState}
              associateCItoRequest={associateCItoRequest}
              handleRemoveCI={handleRemoveCI}
              setCiToRemove={setCiToRemove}
              setModalRemoveCI={setModalRemoveCI}
            />
          ) : (
            <></>
          )}
          {tab === 3 ? (
            <TabFiles
              requestState={requestState}
              uploadedFiles={requestState.files}
              ID={match.params.id}
              modalRemoveFile={modalRemoveFile}
              setModalRemoveFile={setModalRemoveFile}
              filesToRemoveList={filesToRemoveList}
              setfilesToRemoveList={setfilesToRemoveList}
              folder={"1"}
              canUpload={true}
            />
          ) : (
            <></>
          )}
          {tab === 4 ? <TabForm solicitud={requestState.active.StatusName} estado={requestState.active.ServiceOrder?.StatusName} ReqId={match.params.id} /> : <></>}
        </Tab>
      </div>

      {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <div className="px-0 lg:px-8 text-sm sm:text-md">
        <Modal
          height="auto"
          setModalActive={setModalRemoveCI}
          active={modalRemoveCI}

        >
          <ConfirmRemoveCi
            setModalActive={setModalRemoveCI}
            handleRemoveCI={handleRemoveCI}
            ciToRemove={ciToRemove}
          />
        </Modal>
      </div>


      <Modal setModalActive={setModalRemoveFile} active={modalRemoveFile}>
        <FileRemoveModalContent
          setModalActive={setModalRemoveFile}
          list={filesToRemoveList}
          eliminar={handleRemoveFiles}
        />
      </Modal>
      <Footer />
    </div>
  );
};

export default FaqDetail;
